var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "billing-wizard" } }, [
    !_vm.disableCompleteButton
      ? _c(
          "div",
          { staticClass: "stepper-slider" },
          [
            _c("Stepper", {
              attrs: { activeTab: _vm.activeIndex, tabInfo: _vm.stepperData },
              on: {
                changeTab: function (i) {
                  return (_vm.activeIndex = i)
                },
              },
            }),
            _vm._v(" "),
            _vm._m(0),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "setup" }, [
      _c("div", { staticClass: "body" }, [
        _c(
          "div",
          { staticClass: "content" },
          [
            _vm.activeIndex === 0
              ? _c("CustomerPlans", {
                  attrs: {
                    "is-wizard": true,
                    type: "supsis",
                    "is-admin": false,
                    "plan-details": _vm.getPlanDetails("supsis"),
                    "active-plan": _vm.getActivePlan("supsis"),
                    period: _vm.getPeriod("supsis"),
                  },
                  on: {
                    subscribe: _vm.addSubscribe,
                    unsubscribe: _vm.removeUnSubscribe,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.activeIndex === 1
              ? _c("CustomerPlans", {
                  attrs: {
                    "is-wizard": true,
                    type: "chatbot",
                    "is-admin": false,
                    "plan-details": _vm.getPlanDetails("chatbot"),
                    "active-plan": _vm.getActivePlan("chatbot"),
                    period: _vm.getPeriod("chatbot"),
                  },
                  on: {
                    subscribe: _vm.addSubscribe,
                    unsubscribe: _vm.removeUnSubscribe,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.activeIndex === 2
              ? _c("CustomerPlans", {
                  attrs: {
                    "is-wizard": true,
                    type: "whatsapp",
                    "is-admin": false,
                    "plan-details": _vm.getPlanDetails("whatsapp"),
                    "active-plan": _vm.getActivePlan("whatsapp"),
                    period: _vm.getPeriod("whatsapp"),
                  },
                  on: {
                    subscribe: _vm.addSubscribe,
                    unsubscribe: _vm.removeUnSubscribe,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.activeIndex === 3
              ? _c("CustomerPlans", {
                  attrs: {
                    "is-wizard": true,
                    type: "whatsapp-business",
                    "is-admin": false,
                    "plan-details": _vm.getPlanDetails("whatsapp-business"),
                    "active-plan": _vm.getActivePlan("whatsapp-business"),
                    period: _vm.getPeriod("whatsapp-business"),
                  },
                  on: {
                    subscribe: _vm.addSubscribe,
                    unsubscribe: _vm.removeUnSubscribe,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.activeIndex === 4
              ? _c(
                  "div",
                  { staticClass: "preview" },
                  _vm._l(
                    Object.keys(_vm.subscribes).filter(function (x) {
                      return _vm.subscribes[x].plan
                    }),
                    function (key) {
                      return _c("SubscriptionCard", {
                        key: key,
                        attrs: {
                          subscribe: _vm.subscribes[key],
                          details: _vm.subscribes[key].details || {},
                        },
                        on: {
                          deletePlan: function ($event) {
                            return _vm.deletePlan(_vm.subscribes[key].plan)
                          },
                        },
                      })
                    }
                  ),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeIndex <= 4
              ? _c("div", { staticClass: "stepper-buttons" }, [
                  _vm.activeIndex < 4
                    ? _c(
                        "div",
                        {
                          staticClass: "stepper-button",
                          on: {
                            click: function ($event) {
                              _vm.activeIndex--
                            },
                          },
                        },
                        [_vm._v("Geri")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "stepper-button",
                      on: {
                        click: function ($event) {
                          _vm.activeIndex++
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.getNextButtonText()) +
                          "\n                    "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.activeIndex === 5
              ? _c("div", { staticClass: "payment" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "flex-direction": "column",
                        "margin-bottom": "15px",
                        width: "100%",
                        gap: "20px",
                      },
                    },
                    [
                      _vm.sitePaymentMethod === "credit-card"
                        ? _c("CreditCardForm", {
                            on: {
                              input: function (val) {
                                return (_vm.cardForm = val)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("BillingAddressForm", {
                        on: {
                          input: function (val) {
                            return (_vm.billingAddressForm = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("TotalCost", {
                        attrs: {
                          subscribes: _vm.subscribes,
                          disableCompleteButton: _vm.disableCompleteButton,
                        },
                        on: { submit: _vm.complateWizard },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.activeIndex === 6
              ? _c("PlanSelectionCompleted", {
                  on: {
                    clickHandler: function ($event) {
                      return _vm.goBillingPage()
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src: "https://supsis.com/wp-content/uploads/2023/06/supsis_renkli.svg",
          width: "160",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }